/**
 * Calculate the relative luminance of a color
 * Based on WCAG 2.0 formula: https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */
function getLuminance(r, g, b) {
  const [rs, gs, bs] = [r, g, b].map(val => {
    val = val / 255
    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4)
  })
  return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs
}

/**
 * Convert hex color to RGB values
 */
function hexToRgb(hex) {
  // Remove # if present
  hex = hex.replace('#', '')

  // Handle 3-digit hex
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(char => char + char)
      .join('')
  }

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return { r, g, b }
}

/**
 * Parse RGB color string (e.g., "rgb(255, 0, 0)" or "rgba(255, 0, 0, 0.5)")
 */
function parseRgb(rgbString) {
  const match = rgbString.match(/\d+/g)
  if (!match || match.length < 3) return null
  return {
    r: parseInt(match[0], 10),
    g: parseInt(match[1], 10),
    b: parseInt(match[2], 10),
  }
}

/**
 * Determine if a color is light or dark
 * Returns 'white' for dark backgrounds, 'black' for light backgrounds
 * Uses WCAG contrast ratio guidelines
 */
export function getContrastTextColor(backgroundColor) {
  if (!backgroundColor) return 'white'

  let rgb

  // Handle hex colors
  if (backgroundColor.startsWith('#')) {
    rgb = hexToRgb(backgroundColor)
  }
  // Handle rgb/rgba strings
  else if (backgroundColor.startsWith('rgb')) {
    rgb = parseRgb(backgroundColor)
  }
  // Handle named colors (basic support)
  else {
    // Try to parse as hex without #
    try {
      rgb = hexToRgb(backgroundColor)
    } catch {
      // Fallback: assume dark background for unknown colors
      return 'white'
    }
  }

  if (!rgb) return 'white'

  const luminance = getLuminance(rgb.r, rgb.g, rgb.b)

  // If luminance is greater than 0.5, it's a light color, use dark text
  // Otherwise, it's a dark color, use light text
  return luminance > 0.5 ? '#000000' : '#ffffff'
}
